import { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import getButtonStyle from '../utils/getButtonStyle';

function HelpButton({ helpText }) {
    const [showHelp, setShowHelp] = useState(false);
    const { theme } = useTheme();

    return (
        <div style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 1000 }}>
            <button
                onMouseEnter={() => setShowHelp(true)}
                onMouseLeave={() => setShowHelp(false)}
                onClick={() => setShowHelp(!showHelp)}
                style={{
                    ...getButtonStyle(theme, { variant: 'secondary' }),
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    fontSize: '1.2rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                ?
            </button>

            {showHelp && helpText && (
                <div style={{
                    position: 'absolute',
                    top: '50px',
                    right: '0',
                    backgroundColor: theme.bgDark,
                    color: theme.textPrimary,
                    padding: '15px',
                    borderRadius: '10px',
                    maxWidth: '250px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.5)',
                    fontSize: '0.9rem',
                    border: `1px solid ${theme.light}`,
                    zIndex: 1001
                }}>
                    {helpText}
                </div>
            )}
        </div>
    );
}

export default HelpButton;
